import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { int32_type, record_type, option_type, class_type, list_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { ApiToken_CreateTokenResult_$reflection, ApiToken_Filiale_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { GlobalMsg_$reflection, Remote$1, Remote$1_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["ApiToken"];
    }
}

export function Page_$reflection() {
    return union_type("ApiToken.Types.Page", [], Page, () => [[]]);
}

export class Model extends Record {
    constructor(Filialen, SelectedFiliale) {
        super();
        this.Filialen = Filialen;
        this.SelectedFiliale = SelectedFiliale;
    }
}

export function Model_$reflection() {
    return record_type("ApiToken.Types.Model", [], Model, () => [["Filialen", Remote$1_$reflection(list_type(ApiToken_Filiale_$reflection()))], ["SelectedFiliale", option_type(class_type("System.Guid"))]]);
}

export function Model_get_Init() {
    return new Model(new Remote$1(1, []), undefined);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadFilialen", "FilialenLoaded", "SwitchFiliale", "DeleteToken", "DeleteTokenConfirmed", "TokenDeleted", "CreateToken", "TokenCreated", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("ApiToken.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ApiToken_Filiale_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(ApiToken_Filiale_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", class_type("System.Guid")]], [["Item", int32_type]], [["Item", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [ApiToken_CreateTokenResult_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", ApiToken_CreateTokenResult_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

//# sourceMappingURL=Types.fs.js.map
